import { FieldDataType, SchemaField } from 'src/app/modules/core/store/models/document.model';
import {
  dateTimeValueGetter,
  geometryValueGetter,
  textValueGetter,
  userValueGetter,
  numberValueGetter,
  urlValueGetter,
  picklistValueGetter,
  multiPicklistValueGetter,
  imageValueGetter,
  workflowValueGetter,
  booleanValueGetter,
  colorValueGetter,
  distanceValueGetter,
  autoIncrementValueGetter,
  arrayValueGetter,
  cultureCodeValueGetter
} from './document-fields/value-getters';
import { ValueFormatterParams } from 'ag-grid-enterprise';
import { durationValueGetter } from './document-fields/value-getters/duration-value-getter';
import { enumValueGetter } from './document-fields/value-getters/enum-value-getter';
import { buValueGetter } from './document-fields/value-getters/bu-value-getter';
import { referenceValueGetter } from './document-fields/value-getters/reference-value-getter';

export const getCellRenderer = (datType: FieldDataType) => {
  switch (datType) {
    case FieldDataType.DateTime:
      return 'dateTimeCellComponent';

    case FieldDataType.Geometry:
      return 'geometryCellComponent';

    case FieldDataType.Text:
      return 'textCellComponent';

    case FieldDataType.User:
      return 'userCellComponent';

    case FieldDataType.Number:
      return 'numberCellComponent';

    case FieldDataType.Url:
      return 'urlCellComponent';

    case FieldDataType.Picklist:
      return 'picklistCellComponent';

    case FieldDataType.MultiPicklist:
      return 'multiPicklistCellComponent';

    case FieldDataType.Image:
      return 'imageCellComponent';

    case FieldDataType.UId:
      return 'workflowCellComponent';

    case FieldDataType.Boolean:
      return 'booleanCellComponent';

    case FieldDataType.Color:
      return 'colorCellComponent';

    case FieldDataType.Distance:
      return 'distanceCellComponent';

    case FieldDataType.AutoIncrement:
      return 'autoIncrementCellComponent';

    case FieldDataType.Array:
      return 'arrayCellComponent';

    case FieldDataType.CultureCode:
      return 'cultureCodeCellComponent';

    case FieldDataType.Phone:
      return 'phoneCellComponent';

    case FieldDataType.Duration:
      return 'durationCellComponent';

    case FieldDataType.Enumeration:
      return 'enumerationCellComponent';

    case FieldDataType.BusinessUnits:
      return 'businessUnitsCellComponent';

    case FieldDataType.SingleReference:
      return 'referenceCellComponent';

    default:
      return null;
  }
};

export const getValueGetter = (datType: FieldDataType) => {
  switch (datType) {
    case FieldDataType.DateTime:
      return dateTimeValueGetter;

    case FieldDataType.Geometry:
      return geometryValueGetter;

    case FieldDataType.Text:
      return textValueGetter;

    case FieldDataType.User:
      return userValueGetter;

    case FieldDataType.Number:
      return numberValueGetter;

    case FieldDataType.Url:
      return urlValueGetter;

    case FieldDataType.Picklist:
      return picklistValueGetter;

    case FieldDataType.MultiPicklist:
      return multiPicklistValueGetter;

    case FieldDataType.Image:
      return imageValueGetter;

    case FieldDataType.UId:
      return workflowValueGetter;

    case FieldDataType.Boolean:
      return booleanValueGetter;

    case FieldDataType.Color:
      return colorValueGetter;

    case FieldDataType.Distance:
      return distanceValueGetter;

    case FieldDataType.AutoIncrement:
      return autoIncrementValueGetter;

    case FieldDataType.Array:
      return arrayValueGetter;

    case FieldDataType.CultureCode:
      return cultureCodeValueGetter;

    case FieldDataType.Duration:
      return durationValueGetter;

    case FieldDataType.Enumeration:
      return enumValueGetter;

    case FieldDataType.BusinessUnits:
      return buValueGetter;

    case FieldDataType.SingleReference:
      return referenceValueGetter;

    default:
      return null;
  }
};

export const getCellFilter = (datType: FieldDataType) => {
  switch (datType) {
    case FieldDataType.DateTime:
      return 'agDateColumnFilter';

    case FieldDataType.Geometry:
      return null;

    case FieldDataType.Text:
      return 'agSetColumnFilter';

    case FieldDataType.Email:
      return 'agSetColumnFilter';

    case FieldDataType.Phone:
      return 'agSetColumnFilter';

    case FieldDataType.User:
      return 'agSetColumnFilter';

    case FieldDataType.Number:
      return 'agNumberColumnFilter';

    case FieldDataType.Url:
      return 'agTextColumnFilter';

    case FieldDataType.Picklist:
      return 'agSetColumnFilter';

    case FieldDataType.MultiPicklist:
      return 'agTextColumnFilter';

    case FieldDataType.Image:
      return 'agTextColumnFilter';

    case FieldDataType.UId:
      return 'agSetColumnFilter';

    case FieldDataType.Boolean:
      return 'agTextColumnFilter';

    case FieldDataType.Color:
      return 'agTextColumnFilter';

    case FieldDataType.Distance:
      return 'agNumberColumnFilter';

    case FieldDataType.AutoIncrement:
      return 'agSetColumnFilter';

    case FieldDataType.Array:
      return 'agTextColumnFilter';

    case FieldDataType.CultureCode:
      return 'agTextColumnFilter';

    case FieldDataType.SingleReference:
      return 'agSetColumnFilter';

    case FieldDataType.Enumeration:
      return 'agSetColumnFilter';

    default:
      return null;
  }
};

export const getCellSort = (field: SchemaField) => {
  switch (field.dataType) {
    case FieldDataType.User:
      return `${field.systemName}_name`;
    case FieldDataType.SingleReference:
      return `${field.systemName}_display`;

    default:
      return field.systemName;
  }
};

export const getColumnFilterParams = (filter: string) => {
  return {
    buttons: ['reset', 'apply'],
    debounceMs: 1000,
    valueFormatter: filter === 'agSetColumnFilter' ? formatTextForTable : null,
    suppressAndOrCondition: true,
    filterOptions: filter === 'agSetColumnFilter' ? ['equals', 'notEqualNoCase', 'contains', 'notContains', 'blank', 'notBlank'] : undefined
  };
};

export const formatTextForTable = (params: ValueFormatterParams) => {
  const text = params.value;
  if (text) {
    return text.replace(/(\r\n|\n|\r)/gm, '');
  }
  return text;
};
